export const colors = [
  '#4D4D4D',
  '#999999',
  '#FFFFFF',
  '#F44E3B',
  '#FE9200',
  '#FCDC00',
  '#DBDF00',
  '#A4DD00',
  '#68CCCA',
  '#73D8FF',
  '#AEA1FF',
  '#FDA1FF',
  '#333333',
  '#808080',
  '#cccccc',
  '#D33115',
  '#E27300',
  '#FCC400',
  '#B0BC00',
  '#68BC00',
  '#16A5A5',
  '#009CE0',
  '#7B64FF',
  '#FA28FF',
  '#000000',
  '#666666',
  '#B3B3B3',
  '#9F0500',
  '#C45100',
  '#FB9E00',
  '#808900',
  '#194D33',
  '#0C797D',
  '#0062B1',
  '#653294',
  '#AB149E',
];

export type RGBColorType = {
  r: number;
  g: number;
  b: number;
};

export const similarityThreshold = 50;

// Função para calcular a distância euclidiana entre duas cores RGB
export function getColorDistance(color1: RGBColorType, color2: RGBColorType) {
  const rDiff = color1.r - color2.r;
  const gDiff = color1.g - color2.g;
  const bDiff = color1.b - color2.b;
  return Math.sqrt(rDiff * rDiff + gDiff * gDiff + bDiff * bDiff);
}

// Função para calcular a distância euclidiana entre duas cores RGB
export function hexToRgb(hex: string) {
  // Converte o valor hex em uma string sem o '#'
  hex = hex.replace('#', '');

  // Extrai os valores de vermelho, verde e azul (cada um com 2 caracteres)
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Retorna os valores em um objeto com as propriedades r, g e b
  return { r, g, b };
}
